import React from 'react';

import classes from '../../../../assets/Global.module.css';
import Input from '../../../../assets/essentials/Input';
import Select from '../../../../assets/essentials/Select';
import OptionList from '../../../../helpers/options/OptionList';
import TextArea from '../../../../assets/essentials/TextArea';
import Button from '../../../../assets/essentials/Button';
import PutForm from '../../../../api/internal/PutForm';
import Form from '../../../../assets/essentials/Form';
import StatesAndProvinces from '../../../../helpers/options/StatesAndProvinces';
import Close from '../../../../helpers/slab/Close';

function Details({
  datId,
  data,
  options,
}: {
  datId: number;
  data: DATTruckPostBoardItem;
  options: CreateDATTruckPostOptions;
  RefreshPage: Function;
  GetDATTruckPost: Function;
}) {
  const formatDate = (date: string): string => {
    const newDate = new Date(date);
    const year = newDate.getFullYear();
    const month = (newDate.getMonth() + 1).toString().padStart(2, '0'); // Months are 0-based
    const day = newDate.getDate().toString().padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  function UpdateDATTruckPost(e) {
    e.preventDefault();
    const formData = new FormData(e.target);

    // Get today's date for comparison
    const today = new Date();
    // Get the value of the 'earliestAvailableDate' field
    const earliestAvailableDate = formData.get('earliestAvailableDate');

    if (typeof earliestAvailableDate === 'string') {
      const inputDate = new Date(earliestAvailableDate);

      // Remove the field if the date is before today - can't send DAT an earliestAvailableDate in the past
      if (inputDate < today) {
        formData.delete('earliestAvailableDate');
      }
    }

    PutForm(`/DatService/UpdateDATTruckPost/${datId}`, formData).then(res => {
      if (res.data) {
        Close();
      }
    });
  }

  return (
    <Form onSubmit={e => UpdateDATTruckPost(e)}>
      <div className={`${classes.attribute}`}>
        <label htmlFor="datEquipmentType">Equipment</label>
        <Select
          defaultValue={data?.datEquipmentType}
          id="datEquipmentType"
          name="datEquipmentType"
          disabled
        >
          <OptionList
            optionData={options?.datEquipmentTypeOptions}
            attributeID="datEquipmentCode"
            attributeName="datEquipmentTypeName"
          />
        </Select>
      </div>
      <div className={classes.attribute}>
        <label htmlFor="length">
          Length <span className={classes.required}>*</span>
        </label>
        <Select id="length" name="length" defaultValue={data?.length}>
          <option disabled value="">
            -- Required --
          </option>
          <OptionList
            optionData={options?.lengthOptions}
            attributeID="intLength"
            attributeName="displayLength"
          />
        </Select>
      </div>
      <div className={classes.attribute}>
        <label htmlFor="weight">
          Weight <span className={classes.required}>*</span>
        </label>
        <Input
          defaultValue={data?.weight}
          id="weight"
          name="weight"
          type="number"
          min="0"
          max="99999"
          required
          onChange={e => {
            const value = e.target.value;
            if (value.length > 5) {
              e.target.value = value.slice(0, 5);
            }
          }}
        />
      </div>
      <div className={`${classes.attribute}`}>
        <label htmlFor="originCity">
          Origin City <span className={classes.required}>*</span>
        </label>
        <Input
          disabled
          id="originCity"
          name="originCity"
          value={data?.originCity}
        />
      </div>
      <div className={`${classes.attribute} ${classes.span2}`}>
        <label htmlFor="originState">
          Origin State/Province <span className={classes.required}>*</span>
        </label>
        <Select
          disabled
          id="originState"
          name="originState"
          value={data?.originState}
        >
          <option disabled value=""></option>
          <StatesAndProvinces />
        </Select>
      </div>
      <div className={`${classes.attribute}`}>
        <label htmlFor="destinationCity">Destination City</label>
        <Input
          disabled
          id="destinationCity"
          name="destinationCity"
          value={data?.destinationCity}
        />
      </div>
      <div className={`${classes.attribute} ${classes.span2}`}>
        <label htmlFor="destinationState">Destination State/Province</label>
        <Select
          disabled
          id="destinationState"
          name="destinationState"
          value={data?.destinationState || ''}
        >
          <option disabled value=""></option>
          <StatesAndProvinces />
        </Select>
      </div>
      <div className={`${classes.attribute}`}>
        <label htmlFor="earliestAvailableDate">
          Earliest Availability <span className={classes.required}>*</span>
        </label>
        <Input
          id="earliestAvailableDate"
          name="earliestAvailableDate"
          type="date"
          defaultValue={formatDate(data?.earliestAvailableDate)}
          min={formatDate(data?.earliestAvailableDate)}
        />
      </div>
      <div className={`${classes.attribute}`}>
        <label htmlFor="latestAvailableDate">
          Latest Availability <span className={classes.required}>*</span>
        </label>
        <Input
          id="latestAvailableDate"
          name="latestAvailableDate"
          type="date"
          defaultValue={formatDate(data?.latestAvailableDate)}
          min={data?.earliestAvailableDate}
        />
      </div>
      <div className={`${classes.attribute} ${classes.span3}`}>
        <label htmlFor="comment">Comment</label>
        <TextArea
          id="comment"
          name="comment"
          type="date"
          defaultValue={data?.comment}
          maxLength={70}
        />
      </div>
      <div>
        <Button type="submit" variant="good" disabled={true}>
          Save Changes
        </Button>
      </div>
    </Form>
  );
}
export default Details;
